module.exports = __webpack_public_path__ + "static/media/emitirHistorico.1e5014d6.png";